import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/tech-trends/viec-lam-claude-code/ViecLamClient.tsx");
